import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  isDeliveryDisposition,
  isPickupOrCateringDisposition,
  isEmptyObject,
  getValueOrEmptyStringWithComma,
  getToday,
} from 'common/utilities/utils';
import ImageComponent from 'atoms/Image';
import { ASAP, SPACE_REGEX, DATE_FORMATS } from 'common/constants/SharedConstants';
import { formatDateTime } from 'common/utilities/dayJsUtils';

export const getTitlePanel = (title, className = null, children = null) => {
  return (
    <div className={`labelContent info-label pl-25px col-sm-4 col-12 ${className}`}>
      <span>{title}</span>
      {children}
    </div>
  );
};

const getStoreAddressDetails = addresses => {
  if (isEmptyObject(addresses)) {
    const { addressLines, city, state, country, pinCode } = addresses;
    const pinCodeTxt = getValueOrEmptyStringWithComma(pinCode);
    const cityTxt = getValueOrEmptyStringWithComma(city);
    const stateTxt = getValueOrEmptyStringWithComma(state);
    const countryTxt = getValueOrEmptyStringWithComma(country);
    return `${addressLines?.[0]}${cityTxt}${stateTxt}${pinCodeTxt}${countryTxt}`;
  }
  return null;
};

export const getStoreDetailsPanel = (params, children1 = null, children2 = null) => {
  const { type, store, checkoutDetails, address2, icon, displayStoreAddress = true } = params;
  const { date, time, enableScheduleOrder, store: storeDetails, enableClickCollectScheduleOrder } = checkoutDetails;
  const dateArray = time !== ASAP && formatDateTime(date, DATE_FORMATS.MMMM_D)?.split(' ');
  return (
    <>
      <div className='d-flex align-items-start mb-4'>
        <label className='checkoutIcons'>
          <img src={icon} alt='type' />
        </label>
        <div className='d-flex w-100 justify-content-between align-items-start'>
          <div className='addressBox'>
            {displayStoreAddress && (
              <span className='store_name d-block font-weight-bold'>{storeDetails?.summary?.name}</span>
            )}
            {isDeliveryDisposition(type) && (
              <span>
                <span className={displayStoreAddress ? '' : 'store_name d-block font-weight-bold'}>{address2}</span>
                {isEmptyObject(checkoutDetails?.formattedDeliveryAddress) && checkoutDetails?.formattedDeliveryAddress}
              </span>
            )}
            {isPickupOrCateringDisposition(type) && (
              <span>{getStoreAddressDetails(store?.addresses?.[0]?.address)}</span>
            )}
            {children1}
          </div>
          {children2}
        </div>
      </div>
      {(enableScheduleOrder || enableClickCollectScheduleOrder) && (
        <div className='d-flex align-items-start mb-4'>
          <ImageComponent srcFile={IMAGE_PATH?.Clock_Dark} alt='location-icon' className='clock-img' />
          <div className='d-flex w-100 justify-content-between align-items-start'>
            <span className='content-store'>
              {time === ASAP ? (
                <span className='content-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP)}</span>
              ) : (
                <>
                  <span className='content-text'>
                    {' '}
                    {`${translateWithI18Next(dateArray[0]) + ' ' + dateArray[1]}, ${time
                      ?.replace(SPACE_REGEX, '')
                      ?.toLowerCase()}`}
                  </span>
                  , {time?.replace(SPACE_REGEX, '')?.toLowerCase()}
                </>
              )}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export const infoChangeButton = (params, className = null) => {
  const { store, scheduleOrderButtonClickHandler } = params;
  return (
    <button
      type='button'
      variant={'link dark'}
      onClick={event => scheduleOrderButtonClickHandler(event, store)}
      data-testid='schedule-order'
      className={`deliveryInfoContent-button ${className}`}
    >
      {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CHANGE)}
    </button>
  );
};

export const getAddress2DetailsPanel = params => {
  const { address2, type, updateAddressDetails, checkoutDetails, updateCheckoutDetails } = params;
  return (
    isDeliveryDisposition(type) && (
      <div className='addressField'>
        <input
          id={TRANSLATE_MAPPING_KEY.ADDRESS2_PLACE_HOLDER}
          type='text'
          name={TRANSLATE_MAPPING_KEY.ADDRESS2_PLACE_HOLDER}
          data-testid='address-field'
          value={address2}
          className='form-control'
          placeholder={`${translateWithI18Next(TRANSLATE_MAPPING_KEY.ADDRESS2_PLACE_HOLDER)}`}
          onChange={event => updateAddressDetails(event, checkoutDetails, updateCheckoutDetails)}
        />
        <label className='form-label'>{'Address 2'}</label>
      </div>
    )
  );
};

export const getScheduleAtDetailsPanel = params => {
  const { getSchedule, time, date } = params;
  return (
    <div className='d-flex align-items-start mb-2'>
      <label className='checkoutIcons'>
        <img src={IMAGE_PATH?.WatchLaterIcon} alt='' />
      </label>
      <div className='sceduledAt' data-testid='schedule-at'>
        {getSchedule({
          time,
          date,
        })}
      </div>
    </div>
  );
};
